<template>
  <div class="login-page">
  <!-- <div> -->
    <div class="d-flex justify--center mb-3">
      <h2 class="login-title">{{ $t('auth.welcome') }}</h2>
    </div>
    <div v-show="error" class="error d-flex justify--center mb-3">{{ error }}</div>
    <form v-on:submit.prevent="login">
      <va-input
        v-model="data.body.email"
        type="text"
        id="email"
        :label="$t('auth.email')"
      />
      <va-input
        v-model="data.body.password"
        type="password"
        id="password"
        :label="$t('auth.password')"
      />

      <div class="auth-layout__options d-flex align--center justify--space-between">
        <va-checkbox v-model="data.rememberMe" class="mb-0" :label="$t('auth.remember')"/>
        <!-- <router-link class="ml-1 link" to="recover">{{$t('auth.recover_password')}}</router-link> -->
      </div>

      <span v-if="successMessage" class="password-success">{{ successMessage }}</span>
      <div class="d-flex justify--center mt-5">
        <va-button type="submit" class="my-0" :disabled="isLoading" style="text-transform: uppercase;">{{ $t('auth.login') }}</va-button>
      </div>

      <!-- <span v-if="successMessage" class="password-success">{{ successMessage }}</span>
      <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between down-container">
        <button class="btn btn-primary btn-block" type="submit" :disabled="isLoading" >
          {{'auth.login' | translate}}
        </button>
      </div> -->
    </form>
    <!-- <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between down-container">
      <div>
        <span><b>{{ 'auth.forgotPassword' | translate}}&nbsp; <router-link to="recover">{{ 'auth.clickHere' | translate }}</router-link></b></span>
      </div>
    </div> -->
    <div class="loading" v-show="isLoading">
      <hollow-dots-spinner
        :animation-duration="2500"
        :size="60"
        color="#29c4a9"
      />
    </div>
  </div>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners'

export default {
  name: 'login',
  components: {
    HollowDotsSpinner,
  },
  props: ['message'],
  data () {
    return {
      data: {
        body: {
          email: null,
          password: null,
          grant_type: 'password',
          client_id: '1',
          client_secret: 'secretp@ssword',
        },
        rememberMe: false,
      },
      successMessage: this.message,
      error: null,
      isLoading: false,
    }
  },
  methods: {
    login () {
      this.isLoading = true
      var redirect = this.$auth.redirect()
      var userLang = window.navigator.language || window.navigator.userLanguage
      var encodedCredentials = btoa(this.data.body.client_id + ':' + this.data.body.client_secret)

      this.$auth.login({
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': userLang,
          'Authorization': 'Basic ' + encodedCredentials,
        },
        data: this.data.body,
        rememberMe: this.data.rememberMe,
        redirect: { name: redirect ? redirect.from.name : this.$auth.user().redirect },
        success (res) {
          console.log('Auth Successfully done')
          console.log('Token: ' + this.$auth.token())
          console.log(this.$auth.user())
          console.log(redirect)

          if (!redirect && this.$auth.user().redirect) {
            //console.log('1')
            // this.$router.replace(redirect.from.name)
            this.$router.replace({ name: this.$auth.user().redirect })
          }
        },
        error (err) {
          this.isLoading = false
          if (err.response) {
            // The request was made, but the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(err.response.status)
            // console.log(err.response.data)
            // console.log(err.response.headers)
            // console.log(err)
            if (err.response.data.error) {
              this.error = this.$t(`server_auth.errors.${err.response.data.error_description.replace(/ /g, '_').toLowerCase()}`)
            } else {
              if (err.response.status === 401) {
                this.error = this.$t(`server_auth.errors.${err.response.data.errors[0].msg.replace(/ /g, '_').toLowerCase()}`)
              } else {
                this.error = this.$t(`server_auth.errors.authentication_failed`)
              }
              /*
              if (err.response.data.message) {
                this.error = err.response.data.message
              } else if (err.response.data.mail) {
                this.error = err.response.data.mail
              } else if (err.response.data.password) {
                this.error = err.response.data.password
              } else {
                this.error = 'A autenticação falhou'
              }
              */
            }
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', err.message)
          }
          console.log(err.config)
        },
      })
    },
  },
  mounted () {
    if (this.$auth.redirect()) {
      console.log('Redirect from: ' + this.$auth.redirect().from.name)
    }
  },
  watch: {
    message: {
      handler: function () {
        setTimeout(() => {
          this.successMessage = null
        }, 3000)
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss">

  .login-page {
    @include media-breakpoint-down(md) {
      width: 100%;
      padding-right: 2rem;
      padding-left: 2rem;
      .down-container {
        .link {
          margin-top: 2rem;
        }
      }
    }

    h2 {
      text-align: center;
      margin-bottom: 1rem;
      color: $evollu-gray-dark;
      font-size: 2rem;
      text-transform: none;
    }
    // width: 21.375rem;

    .down-container {
      margin-top: 3.125rem;
    }

    .error {
      text-align: center;
      margin-bottom: 1rem;
      color:red;
      word-wrap:break-word;
    }
  }

  .loading {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 40%;
    left: 50%;
  }

  .password-success{
    display: flex;
    justify-content: center;
    font-weight: bold;
    color: #29c4a9;
  }

</style>
